import React from 'react';
import '../styles/gallery.scss';
import { useRef, useState, useEffect } from 'react';

import photoD1 from '../assets/photoD1.jpg';
import photoD2 from '../assets/photoD2.jpg';
import photoD3 from '../assets/photoD3.jpg';
import photoD4 from '../assets/photoD4.jpg';
import photoD5 from '../assets/photoD5.jpg';
import photoD6 from '../assets/photoD6.jpg';
import photoD7 from '../assets/photoD7.jpg';
import photoD8 from '../assets/photoD8.jpg';

const galleryData1 = {
  name: 'Daniel Boey',
  photos: [
    {
      title: 'Robert Cleveland',
      subTitle: 'Senior Vice President, Infant Nutrition',
      desktop: photoD2,
      mobile: photoD2,
      desc: `“The infant formula shortage was a rallying cry for our whole company. Our founder was a parent in need. That’s the reason we’re here. Everyone at Reckitt and Enfamil is ready to do extraordinary things to deliver on that purpose.”`,
      number: 1
    },
    {
      title: 'Daysha Head',
      subTitle: 'Supervisor, Consumer Resource Center',
      desktop: photoD5,
      mobile: photoD5,
      desc: `“I was pregnant during the shortage. Part of me was looking ahead, wondering, ‘how am I going to feed my baby?’ As an employee– and as a mom– it gives me a lot of comfort to know that Enfamil is going that extra mile.”`,
      number: 2
    },
    {
      title: 'Steve Becker',
      subTitle: 'Metrology Engineer',
      desktop: photoD6,
      mobile: photoD6,
      desc: `“We knew we were going to have to step up to the plate. Sometimes it meant longer hours. Sometimes a little fatigue. What I’m most proud of is the teamwork that came together to make it happen.”`,
      number: 3
    },
    {
      title: 'Jennifer Ehling, RD',
      subTitle: 'Medical Sales Manager',
      desktop: photoD8,
      mobile: photoD8,
      desc: `“Enfamil has been around for a hundred-plus years. It’s the number one brand recommended by pediatricians. And the number one ingredient, I believe, is trust.”`,
      number: 4
    },
    {
      title: 'Melissa Emory',
      subTitle: 'Senior Manager, Consumer Resource Center',
      desktop: photoD4,
      mobile: photoD4,
      desc: `“At one point, I think we had 14,000 phone calls in a single day, but my team stepped up in a way that is incredible. I can’t say enough about how they responded. They– we– are really looking out for our Enfamil babies as our own.”`,
      number: 5
    },
    {
      title: 'Claudia SanJuan',
      subTitle: 'Mother',
      desktop: photoD1,
      mobile: photoD1,
      desc: `“I really trust Enfamil. My pediatrician recommended Enfamil Nutramigen. And when I couldn’t find formula on the shelves, it was Enfamil that took care of my family. ”`,
      number: 6
    },
    {
      title: 'Dr. Niall Mullane',
      subTitle: 'Director, Quality',
      desktop: photoD3,
      mobile: photoD3,
      desc: `“Safety and quality starts with the passion of our employees. It’s the core of what we do, and there’s zero margin for error. Even under the pressure of an unfolding crisis– if it couldn’t be done safely, Enfamil looked for a better way.”`,
      number: 7
    },
    {
      title: 'Latisha Minor',
      subTitle: 'Line Supervisor, Two-Ounce Liquids',
      desktop: photoD7,
      mobile: photoD7,
      desc: `“Some places you work are just a job. This is not one of them. We’re all coming together– almost like a family– and we’re feeding our babies. This year, we did what we had to. We rallied to get it done. It feels good just to be a part of that.”`,
      number: 8
    }
  ]
};

const Gallery = () => {
  const nextButton = useRef();
  const photoView = useRef();
  const descView = useRef();

  const [intervalId, setIntervalId] = useState();
  const [currentPhoto, setCurrentPhoto] = useState(galleryData1.photos[0]);

  const index = useRef(0); //tracks change of opacity of photos
  const index2 = useRef(0); //tracks photo index

  //setting up autoplay
  useEffect(() => {
    let i = index.current;
    let i2 = index2.current;
    const startSlideShow = setInterval(() => {
      //setting up photo to fade
      if (i === 0) {
        photoView.current.style.opacity = '0.1';
        descView.current.style.opacity = '0.1';
        i++;
      } else {
        if (i2 < 7) {
          i2++;
          setCurrentPhoto(galleryData1.photos[i2]);
          photoView.current.style.opacity = '1';
          descView.current.style.opacity = '1';
          //if it reaches end of photo reset to first
        } else if (i2 >= 7) {
          i2 = 0;
          setCurrentPhoto(galleryData1.photos[i2]);
          photoView.current.style.opacity = '1';
          descView.current.style.opacity = '1';
        }
        i--;
      }
    }, 3000);
    setIntervalId(startSlideShow);
    return () => window.clearInterval(intervalId);
  }, []);

  //handles next/back button: autoplay is stopped when these are clicked
  const clickHandle = (next) => {
    let index = currentPhoto.number - 1;
    window.clearInterval(intervalId);
    setIntervalId(null);

    if (photoView.current) {
      if ((photoView.current.style.opacity = '0.1')) {
        photoView.current.style.opacity = '1';
        descView.current.style.opacity = '1';
      }
      if (photoView.current.style.animation === '') {
        photoView.current.style.animation = 'photo-appear 1.5s ease-in';
        descView.current.style.animation = 'photo-appear 1.5s ease-in';
      } else if (photoView.current.style.animationName === 'photo-appear') {
        photoView.current.style.animation = 'photo-appear2 1.5s ease-in';
        descView.current.style.animation = 'photo-appear2 1.5s ease-in';
      } else if (photoView.current.style.animationName === 'photo-appear2') {
        photoView.current.style.animation = 'photo-appear 1.5s ease-in';
        descView.current.style.animation = 'photo-appear 1.5s ease-in';
      }

      if (next === 'next') {
        if (index < 7) {
          setCurrentPhoto(galleryData1.photos[index + 1]);
        } else {
          setCurrentPhoto(galleryData1.photos[0]);
        }
      } else {
        if (index > 0) {
          setCurrentPhoto(galleryData1.photos[index - 1]);
        } else {
          setCurrentPhoto(galleryData1.photos[7]);
        }
      }
    }
  };

  return (
    <>
      <div className="galleryHeader">
        <div className="galleryHeader__text">
          <h5>Enfamil Heroes</h5>
          <p>
            Enfamil’s workforce rallied, responded, and, today, are continuing to do everything in
            their power to feed America’s infants with{' '}
            <span className="bold"> a formula that parents and physicians can trust.</span>
          </p>
        </div>
      </div>
      <section className="gallery">
        <div className="gallery__contents">
          <div className="photoContainer">
            <picture className="photoContainer__photo" ref={photoView}>
              <source srcSet={currentPhoto.desktop} media="(min-width: 461px)" />
              <source srcSet={currentPhoto.mobile} media="(max-width: 460px)" />
              <img src={currentPhoto.desktop} alt={galleryData1.name}></img>
            </picture>
          </div>
          <div className="descContainer">
            <div className="descContainer__head">
              <div className="descContainer__head__page">{currentPhoto.number} OF 8</div>
            </div>
            <div className="descContainer__description" ref={descView}>
              <p className="description--copy">{currentPhoto.desc}</p>
              <div className="descContainer__head__title">{currentPhoto.title}</div>
              <div className="descContainer__head__subTitle">{currentPhoto.subTitle}</div>
            </div>
            <div className="descContainer__nav">
              <button
                onClick={() => {
                  clickHandle('back');
                }}
                className="descContainer__nav__buttons descContainer__head__page"
                id="back"
              >
                BACK
              </button>
              |
              <button
                onClick={() => {
                  clickHandle('next');
                }}
                className="descContainer__nav__buttons descContainer__head__page"
                ref={nextButton}
                id="next"
              >
                NEXT
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
